import { render, staticRenderFns } from "./ImpressumSeite.vue?vue&type=template&id=a40de28e&"
import script from "./ImpressumSeite.vue?vue&type=script&lang=js&"
export * from "./ImpressumSeite.vue?vue&type=script&lang=js&"
import style0 from "./ImpressumSeite.vue?vue&type=style&index=0&id=a40de28e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports